import dayjs from 'dayjs';
import { validationRulesLib } from 'shared';

const parseDate = (date: string) => dayjs(date, 'DD.MM.YYYY');

export const createPassportDateValidators = () => {
  const isDateInRange = (value: string) => {
    if (!value) return true;
    const date = parseDate(value);
    const now = dayjs();

    return (
      validationRulesLib.isValidDate(value) &&
      !date.isAfter(now) &&
      !date.isBefore(now.subtract(10, 'year'))
    );
  };

  const requiredIfSelected = (
    value: string,
    parent: { isSelected: boolean },
  ) => {
    if (!parent?.isSelected) return true;
    return !!value?.trim();
  };

  return {
    requiredIfSelected,
    isDateInRange,
  };
};
